export default {
  ACTIVE: 1,
  INACTIVE: 2,
  REVIEWED: 3,
  SUSPENDED: 6,
  NEW: 7,
};

// export default {
//   ACTIVE: 'ACT',
//   INACTIVE: 'INACTIVE',
//   REVIEWED: 'REV',
//   SUSPENDED: 'SUS',
//   NEW: 'NEW',
// };
